"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_rangeslider_1 = __importDefault(require("react-rangeslider"));
require("react-rangeslider/lib/index.css");
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
require("./RangeSlider.scss");
const RangeSlider = ({ className, min, max, value, handleChange, onChangeComplete, disabled }) => {
    const containerCN = (0, classnames_template_literals_1.default)(`
    happy5-slider
    ${className && className}
    ${disabled && 'disabled cursor-not-allowed'}
  `);
    return (react_1.default.createElement("div", { className: containerCN },
        react_1.default.createElement("div", { className: "slider custom-labels" },
            react_1.default.createElement(react_rangeslider_1.default, { min: min, max: max, value: Number(value), onChange: (value) => !disabled && handleChange && handleChange(value), onChangeComplete: (value) => !disabled && onChangeComplete && onChangeComplete(value), tooltip: false }))));
};
exports.default = RangeSlider;
